import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { T } from "@/constants/testIds";
import { useLang } from "@/lib/i18n";

export default function NewsletterSignup() {
  const { lang } = useLang();
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) return toast.error("Please confirm consent to subscribe.");
    setBusy(true);
    try {
      const { data } = await api.post("/forms/newsletter", { email, language: lang, consent: true });
      if (data.already_subscribed) toast.info("You are already subscribed. Thank you!");
      else toast.success("Thank you. You will hear from us shortly.");
      setEmail("");
      setConsent(false);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="py-20 sm:py-24 bg-paper border-t border-border">
      <div className="container-editorial max-w-3xl text-center">
        <span className="eyebrow">Newsletter</span>
        <h2 className="heading-2 mt-3">Receive the reading — thoughtful, occasional.</h2>
        <p className="body-copy mt-4 text-ink-muted">
          A short editorial letter, roughly monthly — Scripture, articles, and reflection. Unsubscribe at any time.
        </p>
        <form data-testid={T.newsletterForm} onSubmit={submit} className="mt-8 flex flex-col sm:flex-row items-stretch gap-3 max-w-xl mx-auto">
          <input
            data-testid={T.newsletterEmail}
            type="email"
            required
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1 border border-border bg-paper px-4 py-3 text-sm focus:outline-none focus:border-ink"
          />
          <button data-testid={T.newsletterSubmit} disabled={busy} className="btn-primary justify-center">
            {busy ? "Sending…" : "Subscribe"}
          </button>
        </form>
        <label className="mt-4 flex items-start gap-2 text-xs text-ink-muted max-w-xl mx-auto text-left">
          <input
            data-testid={T.newsletterConsent}
            type="checkbox"
            checked={consent}
            onChange={(e) => setConsent(e.target.checked)}
            className="mt-1"
          />
          <span>
            I consent to receive occasional emails from Anant Jeevan and understand I can unsubscribe at any time.
          </span>
        </label>
      </div>
    </section>
  );
}
